function deepOmit(source, filters) {
  let clonedObj = {};

  if (!source) return null;

  Object.entries(source).forEach(([key, val]) => {
    if (!filters.includes(key)) {
      if (typeof val === 'object') {
        clonedObj[key] = Array.isArray(val) ? val.map(el => deepOmit(el, filters)) : deepOmit(val, filters);
      } else {
        clonedObj[key] = val;
      }
    }
  });

  return clonedObj;
}

export default deepOmit;



// WEBPACK FOOTER //
// ./src/helpers/deepOmit.js